// extracted by mini-css-extract-plugin
module.exports = {"case_tree":"CaseTree_case_tree__38t7S","title":"CaseTree_title__1s8rg"};